import Agnesi1 from '../../../media/Residentials/Agnesi/Agnesi.webp'
import Agnesi2 from '../../../media/Residentials/Agnesi/Agnesi (2).webp'
import Agnesi3 from '../../../media/Residentials/Agnesi/Agnesi (3).webp'
import Agnesi4 from '../../../media/Residentials/Agnesi/Agnesi (4).webp'
import Agnesi5 from '../../../media/Residentials/Agnesi/Agnesi (5).webp'
import Agnesi6 from '../../../media/Residentials/Agnesi/Agnesi (6).webp'
import Agnesi7 from '../../../media/Residentials/Agnesi/Agnesi (7).webp'
import Agnesi8 from '../../../media/Residentials/Agnesi/Agnesi (8).webp'
import Agnesi9 from '../../../media/Residentials/Agnesi/Agnesi (9).webp'
import Agnesi10 from '../../../media/Residentials/Agnesi/Agnesi (10).webp'
import Agnesi11 from '../../../media/Residentials/Agnesi/Agnesi (11).webp'
import Agnesi12 from '../../../media/Residentials/Agnesi/Agnesi (12).webp'

const Agnesiimages =[
Agnesi1,Agnesi2,Agnesi3,Agnesi4,Agnesi5,Agnesi6,Agnesi7,Agnesi8,Agnesi9,Agnesi10,Agnesi11,Agnesi12
]

export default Agnesiimages;